<app-modal [title]="'Reminders Search'">
  <app-filter
    [fields]="fields"
    [searchData]="searchData"
    (search)="doSearch($event)"
    (resetSearch)="doSearch(null)"
  ></app-filter>
</app-modal>
